import { Patients } from "../models/patients";
import { Response } from "@angular/http";
import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { HttpParams } from "@angular/common/http";
import { NgbDateFRParserFormatter } from "../ngb-date-fr-parser-formatter";
import { Pays } from "../models/pays";
import { Personne } from "../models";
import { InformationPatient } from "app/models/information-patient";

@Injectable()
export class PatientService {
  public url = `/api/patients`;

  constructor(
    private http: HttpClient,
    private dateFrParser: NgbDateFRParserFormatter
  ) {}

  public find(params?: any): Observable<HttpResponse<Patients[]>> {
    let httpParams = new HttpParams();
    if(params){
       httpParams = new HttpParams()
        .set("size", "50")
        .set("sortName", "id")
        .set("sortType", "DESC");}
        else{ httpParams = new HttpParams()
          .set("size", "1000")
          .set("sortName", "id")
          .set("sortType", "DESC");}
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    console.log(params, httpParams);

    return this.http.get<Patients[]>(this.url, {
      observe: "response",
      params: httpParams
    });
  }
  /**
   * create a  new patients
   * @param patient
   */
  create(patient: Patients) {
    return this.http.post(this.url, patient).map(data => {
      console.log(data);
      return data;
    });
  }
  /**
   * update a patient
   * @param patient
   */
  update(patient: Patients) {
    return this.http.put(`${this.url}/${patient.id}`, patient).map(data => {
      console.log(data);
      return data;
    });
  }

  /**
   * update a patient
   * @param patient
   */
  updatewithout(patient: Patients) {
    return this.http.put(`${this.url}/withoutlog/${patient.id}`, patient).map(data => {
      console.log(data);
      return data;
    });
  }
  /**
   * update a patient
   * @param idPatient
   * @param idContact
   * @param contact
   */
  updateContact(idpatient: number, contact: Personne) {
    return this.http
      .put(`${this.url}/${idpatient}/contacts/${contact.id}`, contact)
      .map(data => {
        console.log(data);
        return data;
      });
  }

  /**
   * get a patient by  id
   * @param patient_id
   */
  get(id: number): Observable<Patients> {
    return this.http.get<Patients>(`${this.url}/${id}`).map(p => {
      p.datenaissance = this.dateFrParser.parse(p.datenaissance);
      return p;
    });
  }

  /**
   * recuperer la liste de tout les cni
   */
  getAllCNI(): Observable<string[]> {
    return this.http.get<string[]>(`${this.url}/cni`);
  }
  /**
   * see:list all codes http://www.trucsweb.com/tutoriels/internet/iso_3166/
   */

  getVilles(): Observable<string[]> {
    return Observable.of(["Dakar", "Pikine", "Rufisque", "Thies", "Autres"]);
  }
  getLangues(): Observable<string[]> {
    return Observable.of([
      "WOLOF",
      "PEUL",
      "SERERE",
      "FRANCAIS",
      "ANGLAIS",
      "AUTRES"
    ]);
  }

  getCivilite(): Observable<string[]> {
    return Observable.of(["Mr", "Mme", "Mlle", "Autres"]);
  }

  getMatrimoniales(): Observable<string[]> {
    return Observable.of([
      "Celibataire",
      "Marié",
      "Divorcé",
      "Veuf(ve)",
      "Autres"
    ]);
  }

  getCorps(): Observable<string[]> {
    return Observable.of([
      "Gendarmerie",
      "Police",
      "Sappeur",
      "Douane",
      "Service Hygienne"
    ]);
  }
  /**
   * datenaissance est type date
   * Formats the given date to a string. Implementations
   * should return an empty string if the given date is null,
   *  and try their best to provide a partial result if the given date is incomplete
   *  or invalid.
   * @param patient
   */
  public formatDate(patient: Patients) {
    if (patient.datenaissance) {
      patient.datenaissance = this.dateFrParser.format(patient.datenaissance);
    }
    return patient;
  }
  /**
   * datenaissance est type date
   * @param patient: Parses the given value to an NgbDateStruct.
   * Implementations should try their best to provide a result, even partial.
   *  They must return null if the value can't be parsed.
   */
  public parseDate(patient: Patients) {
    if (patient.datenaissance) {
      patient.datenaissance = this.dateFrParser.parse(patient.datenaissance);
    }

    if (patient.dateCreation) {
      patient.dateCreation = this.dateFrParser.parse(patient.dateCreation);
    }
    return patient;
  }


  //upload file
  /**
   * get a patient by  id
   * @param patient_id
   */
  getInformationByPatient(id: number): Observable<InformationPatient[]> {
    return this.http.get<InformationPatient[]>(`${this.url}/information/${id}`);
  }

  createInformation(information: InformationPatient) {
    return this.http.post(this.url+"/information", information).map(data => {
      return data;
    });
  }

  updateInformation(information: InformationPatient) {

    return this.http.put(`${this.url}/information/${information.id}`, information);
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/patient.service.ts